export const getPercentOfTotal = (value: number, total: number): string => {
  if (!total || total <= 0) return '0';
  return ((value / total) * 100).toFixed(0);
};

export const getACGeneralInfoMetrics = (acData: Record<string, any> = {}, budget?: Record<string, any>) => {
  const acmevTotal = (acData.acmev || 0) + (acData.acmev_used || 0);
  const bmevTotal = (acData.bmev ?? budget?.bmev ?? 0) + (acData.bmev_used ?? budget?.bmev_used ?? 0);

  const achov = acData.achov ?? acData.achov ?? 0;
  const bhov = acData.bhov ?? budget?.bhov ?? 0;

  const acoh = acData.acoh ?? 0;
  const btoh = budget?.btoh ?? acData.btoh ?? 0;

  const btrt = acData.btrt ?? budget?.btrt ?? 0;

  return {
    acmevTotal,
    acmevPercent: getPercentOfTotal(acmevTotal, bmevTotal),
    achov,
    acohvPercent: getPercentOfTotal(achov, bhov),
    acoh,
    acohPercent: getPercentOfTotal(acoh, btoh),
    acrtPercent: getPercentOfTotal(acData.acrt ?? 0, btrt)
  };
};
